import axios from 'axios'
import $ from 'jquery'

/*------------------------------
Collection renderer
------------------------------*/
const collection = {
  render: function (ws) {
    const $nodes = []
    return axios.get(ws).then(({ data, headers }) => {
      const total = headers['x-wp-total']
      const pages = headers['x-wp-totalpages']
      const template = $('#collection-card-template').text()
      for (const item of data) {
        const { link, name, acf, parent_name } = item
        const locale = {
          '{link}': link,
          '{title}': name || '',
          '{image}': acf.image ? acf.image.url : '',
          '{category}': parent_name || '',
        }

        $nodes.push($(
          template.replace(
            /{link}|{title}|{image}|{category}/gi
            , matched => locale[matched])
        ))
      }

      return {
        $nodes,
        pages,
        total,
      }
    })
  }
}


/*------------------------------
Products renderer
------------------------------*/
const product = {
  render: function (ws) {
    const $nodes = []
    return axios.get(ws).then(({ data, headers }) => {
      const total = headers['x-wp-total']
      const pages = headers['x-wp-totalpages']
      const template = $('#product-card-template').text()
      for (const item of data) {
        const { link, title, acf, _cta_collections, featured_image_thumbnail, imageAmbiente } = item        
        const locale = {
          '{link}': link,
          '{title}': title.rendered,
          '{new}': acf.isnew !== 1 ? ' hidden' : '',
          '{image}': (typeof acf.hover_image  !== 'undefined' && acf.hover_image  !== null && acf.hover_image  !== false) ? acf.hover_image.sizes.thumbnailHover : acf.imageAmbiente ? acf.imageAmbiente.sizes.thumbnailHover : featured_image_thumbnail,
          '{category}': _cta_collections.children && _cta_collections.children.length > 0  ? _cta_collections.children[0].name : '',
          '{thumbnail}': featured_image_thumbnail || '',
          '{categorylink}': _cta_collections.children && _cta_collections.children.length > 0  ? window.categorylinkbase + _cta_collections.children[0].slug : '#',
        }
        $nodes.push($(
          template.replace(
            /{categorylink}|{link}|{title}|{image}|{category}|{thumbnail}|{new}/gi
            , matched => locale[matched])
        ))
      }

      return {
        $nodes,
        pages,
        total,
      }
    })
  }
}


/*------------------------------
News renderer
------------------------------*/
const news = {
  render: function (ws) {
    const $nodes = []
    return axios.get(ws).then(({ data, headers }) => {
      const total = headers['x-wp-total']
      const pages = headers['x-wp-totalpages']
      const template = $('#news-card-template').text()
      for (const item of data) {
        const { link, title, cover, featured_media_sizes } = item
        const { thumbnailVertical2x } = featured_media_sizes
        const locale = {
          '{link}': link,
          '{title}': title.rendered,
          '{thumbnail}': cover.thumbnailVertical2x,
          '{size}': `${thumbnailVertical2x[1]}x${thumbnailVertical2x[2]}`,
        }

        $nodes.push($(
          template.replace(
            /{title}|{link}|{thumbnail}|{size}/gi
            , matched => locale[matched])
        ))
      }

      return {
        $nodes,
        pages,
        total,
      }
    })
  }
}


/*------------------------------
Inspirations renderer
------------------------------*/
const inspiration = {
  render: function (ws) {
    const $nodes = []
    return axios.get(ws).then(({ data, headers }) => {
      const total = headers['x-wp-total']
      const pages = headers['x-wp-totalpages']
      const template = $('#inspiration-card-template').text()
      for (const item of data) {
        const { title, rawcontent, prodotto, featured_media_sizes } = item
        const { thumbnailVertical2x, full } = featured_media_sizes
        console.log(item, prodotto)
        const locale = {
          '{thumbnail}': thumbnailVertical2x[0],
          '{description}': rawcontent,
          '{title}': title.rendered,
          '{zoom}': full[0],
          '{size}': `${full[1]}x${full[2]}`,

          '{product-thumb}': prodotto.featured_media_sizes.thumbnail[0],
          '{product-link}': prodotto.link,
          '{product-name}': prodotto.post_title,
          '{product-cat}': prodotto._cta_collections.children.lenght > 0 ? prodotto._cta_collections.children[0].name : '',
        }

        $nodes.push($(
          template.replace(
            /{thumbnail}|{zoom}|{title}|{description}|{size}|{product-thumb}|{product-link}|{product-name}|{product-cat}/gi
            , matched => locale[matched])
        ))
      }

      return {
        $nodes,
        pages,
        total,
      }
    })
  }
}


/*------------------------------
Export
------------------------------*/
export default {
  inspiration,
  collection,
  product,
  news,
}